/* eslint-disable no-undef */
import KAMPYLE_ANIMATION from "./KAMPYLE_ANIMATION";
import KAMPYLE_COMMON from "./KAMPYLE_COMMON";
import KAMPYLE_CONSTANT from "./KAMPYLE_CONSTANT";
import KAMPYLE_DATA from "./KAMPYLE_DATA";
import KAMPYLE_EVENT_DISPATCHER from "./KAMPYLE_EVENT_DISPATCHER";
import KAMPYLE_UTILS from "./KAMPYLE_UTILS";
import MDIGITAL_CONFIGURATION from "./MDIGITAL_CONFIGURATION";

import MDIGITAL_FORM_STATE from "./MDIGITAL_FORM_STATE";
import MDIGITAL_ON_PREM from "./MDIGITAL_ON_PREM";
import KAMPYLE_VIEW from "./KAMPYLE_VIEW";
import KAMPYLE_TARGETING from "./KAMPYLE_TARGETING";
import KAMPYLE_MESSAGE from "./KAMPYLE_MESSAGE";
import MDIGITAL_LOCALIZATION from "./MDIGITAL_LOCALIZATION";
import MDIGITAL_EMBEDDED from "./MDIGITAL_EMBEDDED";

import KAMPYLE_INTEGRATION from "./KAMPYLE_INTEGRATION";
import CUSTOM_EVENTS from "./CUSTOM_EVENTS";
import CUSTOM_PARAMETERS from "./CUSTOM_PARAMETERS";
import KAMPYLE_SCREEN_CAPTURE from "./KAMPYLE_SCREEN_CAPTURE";

import KAMPYLE_GA from "../integrations/google-analytics";
import KAMPYLE_ADOBE_ANALYTICS from "../integrations/adobe-analytics";
import MDIGITAL_DECIBEL from '../integrations/decibel';
import KAMPYLE_FUNC from "./KAMPYLE_FUNC";
import MDIGITAL_ANALYTICS from './MDIGITAL_ANALYTICS';
import MDIGITAL_MODAL_DIALOGS from './MDIGITAL_MODAL_DIALOGS';
import MDIGITAL_PARTIAL_VIEW from "./MDIGITAL_PARTIAL_VIEW";

  function init() {
    MDIGITAL_FORM_STATE.init();
    subscribeFirstToPageEvents();
    KAMPYLE_VIEW.init();
    MDIGITAL_EMBEDDED.init();

    MDIGITAL_MODAL_DIALOGS && MDIGITAL_MODAL_DIALOGS.init();

    KAMPYLE_TARGETING.init();
    KAMPYLE_MESSAGE.init();
    KAMPYLE_ANIMATION.init();

    var formattedFormData = MDIGITAL_CONFIGURATION.getOnsiteConfiguration() || {};

    formattedFormData = validateFormContract(formattedFormData);

    // Replace form url path
    if(KAMPYLE_FUNC.checkProvision(KAMPYLE_CONSTANT.PROVISIONS.ON_PREM_HYBRID)) {
      formattedFormData.formNodes.forEach(MDIGITAL_ON_PREM.replaceFormNodeUrls);
      formattedFormData.globalResourcesUrl = MDIGITAL_ON_PREM.replaceOnPremPrefixes(formattedFormData.globalResourcesUrl);
    }

    KAMPYLE_DATA.setMemoryData(KAMPYLE_CONSTANT.MEMORY_DATA_FIELDS.DATA_JSON, formattedFormData);

    var context = KAMPYLE_UTILS.getUrlParam('nebContext') || window.MDIGITAL.nebContext || 'live';

    KAMPYLE_DATA.setMemoryData('context', context);
    KAMPYLE_DATA.setMemoryData('kampyleDevice', checkDevice());
    KAMPYLE_DATA.setMemoryData('hostedViewportContent', []);
    // this is the first notion of customer profile
    KAMPYLE_DATA.setMemoryData('isGuest', true);

    if (KAMPYLE_DATA.getMemoryData('context') !== 'preview') {
     if({"isOnPremEnabled":false,"isDigitalAnalyticsEnabled":true,"isAnalyticsTrackerEnabled":true,"isCustomEventsEnabled":true,"isScreenCaptureEnabled":true,"isPropertyMessageEnabled":true,"isAdobeAEnabled":true,"isGAEnabled":false,"isDecibelEnabled":false,"isThermoFisherTeaLeafEnabled":false,"isPartialViewEnabled":false}.isGAEnabled) {
      KAMPYLE_GA.init();
     }
     if({"isOnPremEnabled":false,"isDigitalAnalyticsEnabled":true,"isAnalyticsTrackerEnabled":true,"isCustomEventsEnabled":true,"isScreenCaptureEnabled":true,"isPropertyMessageEnabled":true,"isAdobeAEnabled":true,"isGAEnabled":false,"isDecibelEnabled":false,"isThermoFisherTeaLeafEnabled":false,"isPartialViewEnabled":false}.isAdobeAEnabled) {
      KAMPYLE_ADOBE_ANALYTICS.init();
     }
    }

    if({"isOnPremEnabled":false,"isDigitalAnalyticsEnabled":true,"isAnalyticsTrackerEnabled":true,"isCustomEventsEnabled":true,"isScreenCaptureEnabled":true,"isPropertyMessageEnabled":true,"isAdobeAEnabled":true,"isGAEnabled":false,"isDecibelEnabled":false,"isThermoFisherTeaLeafEnabled":false,"isPartialViewEnabled":false}.isDecibelEnabled) {
      MDIGITAL_DECIBEL.init();
    }

    if({"isOnPremEnabled":false,"isDigitalAnalyticsEnabled":true,"isAnalyticsTrackerEnabled":true,"isCustomEventsEnabled":true,"isScreenCaptureEnabled":true,"isPropertyMessageEnabled":true,"isAdobeAEnabled":true,"isGAEnabled":false,"isDecibelEnabled":false,"isThermoFisherTeaLeafEnabled":false,"isPartialViewEnabled":false}.isCustomEventsEnabled) {
      CUSTOM_EVENTS.init();
    }

    if (KAMPYLE_FUNC.checkProvision(KAMPYLE_CONSTANT.PROVISIONS.ENABLE_PARTIAL_VIEW)) {
      MDIGITAL_PARTIAL_VIEW && MDIGITAL_PARTIAL_VIEW.init();
    }

    createSession();
    subscribeToPageEvents();
    subscribeToCustomEvents();

    KAMPYLE_UTILS.setEventHandler(window, 'hashchange', handleHashChanged);

    if(KAMPYLE_FUNC.checkProvision(KAMPYLE_CONSTANT.PROVISIONS.SPA_URL_POLLING)) {
      KAMPYLE_DATA.setMemoryData('currentUrl', window.location.href);
      var urlInterval = setInterval(function() {
        if (window.location.href !== KAMPYLE_DATA.getMemoryData('currentUrl')) {
          KAMPYLE_DATA.setMemoryData('currentUrl', window.location.href);
          KAMPYLE_ONSITE_SDK.updatePageView();
        }
      }, 500);
    }
  }

  function validateFormContract(formsObj) {
    formsObj.formNodes = formsObj.formNodes || [];
    var currForm;
    for (var i = formsObj.formNodes.length - 1; i >= 0; i--) {
      currForm = formsObj.formNodes[i];
      if (!currForm.formHeight || currForm.formHeight === 'null') {
        currForm.formHeight = KAMPYLE_CONSTANT.FORM_HEIGHT;
      }
      if (!currForm.formWidth || currForm.formWidth === 'null') {
        currForm.formWidth = KAMPYLE_CONSTANT.FORM_WIDTH;
      }
    }

    return formsObj;
  }

  function subscribeFirstToPageEvents() {
    var eventMapping = {
      neb_inviteReady: [sendInviteInitialData],
      neb_buttonClicked: [loadFormFirst],
      neb_inviteAccepted: [loadFormFirst],
      neb_showInvitation: [prepareInviteTriggeringData],
      neb_sdkPageView: [setInviteState, KAMPYLE_DATA.initOnsiteDefaultState, KAMPYLE_DATA.resetAllFormsLanguagesCode],
    };

    KAMPYLE_EVENT_DISPATCHER.subscribeMany(eventMapping);
  }

  function loadFormFirst(eventName, data) {
    var formState = KAMPYLE_DATA.getFormState(data.formId);
    if (!formState.loaded && !formState.loading) {
      KAMPYLE_EVENT_DISPATCHER.trigger('neb_loadForm', { formId: data.formId });
    }
  }

  function loadMultipileForms(eventName, data) {
    var formIds = (data || {}).formIds || [];
    formIds.forEach(function(fid) {
      KAMPYLE_COMMON.loadForm(fid);
      // call loadform with the current id;
    });
  }

  function routeToForm(eventName, data) {
    data = data || {};
		KAMPYLE_COMMON.closeForm(data.sourceFormId);
		if (!KAMPYLE_COMMON.showForm(data.formId)) {
			throw new Error('Form cannot be loaded');
		}
  }

  function handleInviteApplicationUpdated(eventName, data) {
    data = data || {};
    var shouldShowInvite = (KAMPYLE_DATA.getFormState(data.formId) || {}).inviteShown;
    if (shouldShowInvite && MDIGITAL_FORM_STATE.isInviteLoaded(data.formId) && isJsonDataLoaded(data.formId,true) && !isAnyOtherFormAlreadyShown()) {
      KAMPYLE_VIEW.showInvite("",{formId:data.formId});
      KAMPYLE_EVENT_DISPATCHER.trigger('neb_inviteReady', data);
      KAMPYLE_DATA.setMemoryData('inviteLoadedAndShown',true);
    }
    else if(hasApplicationLoadingFailed(data.formId,true) || isAnyOtherFormAlreadyShown()){
      KAMPYLE_DATA.setFormState(data.formId , {
        inviteShown: false
      });
    }
  }

  function subscribeToCustomEvents() {
    var eventMapping = {
        neb_inviteDeclined: ['neb_displayClosed'],
        neb_formClosed: ['neb_displayClosed'],
    };
    KAMPYLE_EVENT_DISPATCHER.subscribeMany(eventMapping);
  }

  function isFormAlreadyShown(formId){
    //If user click on 'always on' button or sdk_showForm triggered skip inviation should not be shown
    var shouldSkipShowingForm = KAMPYLE_DATA.isSkipInvitation(formId) && isAnyOtherFormAlreadyShown(formId);
    // https://jira.medallia.com/browse/NM-15138
    var isFormShown = MDIGITAL_FORM_STATE.isFormShown(formId);
    if(shouldSkipShowingForm){
      KAMPYLE_EVENT_DISPATCHER.trigger('neb_formReady', {formId:formId});
      KAMPYLE_DATA.setFormState(formId, {
        shouldBeShown: false
      });
      KAMPYLE_EVENT_DISPATCHER.trigger('neb_skipShowingForm', {formId:formId});
    }
    return shouldSkipShowingForm || isFormShown;
  }

  function hasApplicationLoadingFailed(formId,isInvite){
    var jsonDataKey = KAMPYLE_DATA.getMemoryJsonKey(formId,isInvite);
    var currentMemoryData = KAMPYLE_DATA.getMemoryData(jsonDataKey);
    var formState = KAMPYLE_DATA.getFormState(formId);
    return currentMemoryData === false || (!isInvite && formState && formState.loaded === false) || (isInvite && formState && formState.inviteLoaded === false);
  }

  function isJsonDataLoaded(formId,isInvite){
    var jsonDataKey = KAMPYLE_DATA.getMemoryJsonKey(formId,isInvite);
    return !KAMPYLE_FUNC.checkProvision(KAMPYLE_CONSTANT.PROVISIONS.FORM_TEMPLATE_DATA_SEPERATION) || KAMPYLE_DATA.getMemoryData(jsonDataKey);
  }

  function shouldSkipFetchingFormData(formId,isInvite,formLanguage){
    var isFetchingDataInProgressKey = KAMPYLE_CONSTANT.MEMORY_DATA_FIELDS.FETCHING_DATA_IN_PROGRESS+formId+ '_' + formLanguage;
    var isFetchingDataInProgress = KAMPYLE_DATA.getMemoryData(isFetchingDataInProgressKey);
    var dataSeparationProvision = KAMPYLE_FUNC.checkProvision(KAMPYLE_CONSTANT.PROVISIONS.FORM_TEMPLATE_DATA_SEPERATION)
    return !dataSeparationProvision || isJsonDataLoaded(formId,false) || hasApplicationLoadingFailed(formId,isInvite)  || isFetchingDataInProgress;
  }

  function handleFormLoadingFailed(eventName, data){
    //In case we tried loading the form and didnt receive a message back from the form application.
    if(data.failureCause === KAMPYLE_CONSTANT.FORM_LOADING_FAILURE_CAUSE.APPLICATION_FAILED){
      var formData = KAMPYLE_DATA.getFormData(data.formId);
      var displayType = KAMPYLE_DATA.getDisplayType(formData);
      var formState = KAMPYLE_DATA.getFormState(data.formId);
      var eventData = {errorData: {formId: data.formId, displayType: displayType, formState: formState}};
      KAMPYLE_EVENT_DISPATCHER.trigger(KAMPYLE_CONSTANT.EVENTS.MDIGITAL_COULD_NOT_LOAD_FORM_APPLICATION, eventData);
    }

    //Set timeout to run this function after kampyle view check if the form should be shown to render error msg
    setTimeout(function(){
      KAMPYLE_DATA.setFormState(data.formId,{
        shouldBeShown: false,
        loaded: false
      });
    },0);

  }


  function isFormLoaded(formId) {
    var formData = KAMPYLE_DATA.getFormData(formId);
    var displayType = KAMPYLE_DATA.getDisplayType(formData);
    //In popup display type we are loading the application in the popup itself
    return MDIGITAL_FORM_STATE.isFormLoaded(formId);
  }

  function handleInviteVersion(formId){
    var inviteDataKey = KAMPYLE_DATA.getMemoryJsonKey(formId, true);
    var inviteData = KAMPYLE_DATA.getMemoryData(inviteDataKey);
    KAMPYLE_DATA.setMemoryData('inviteVersion', inviteData && inviteData.mobileDesign ? 1 : -1);
  }

  function prepareJsonData(eventName, data) {
    var isInvite = eventName === 'neb_loadInvitation';
    var formLanguage = KAMPYLE_DATA.getMemoryData(KAMPYLE_CONSTANT.LANG_MEMORY_DATA_KEY_PREFIX + data.formId);
    var fetchingDataInProgressKey = KAMPYLE_CONSTANT.MEMORY_DATA_FIELDS.FETCHING_DATA_IN_PROGRESS + data.formId;
    fetchingDataInProgressKey = fetchingDataInProgressKey + '_' + formLanguage;

    if(isInvite){
     fetchingDataInProgressKey = fetchingDataInProgressKey + '_invite';
    }
    if (KAMPYLE_FUNC.shouldSkipFetchingFormData(data.formId,isInvite,formLanguage)) {
      return;
    }
    else{
      KAMPYLE_DATA.setMemoryData(fetchingDataInProgressKey,true);
    }

    KAMPYLE_DATA.fetchFormJsonData({
      formId: data.formId,
      isInvite: isInvite,
      fetchingDataInProgressKey:fetchingDataInProgressKey,
      callback:function(){
        if(isInvite){
          handleInviteVersion(data.formId);
          handleInviteApplicationUpdated("",data);
        }
        else{
          handleFormStateUpdated(data);
        }
      },
      onError: onJsonFetchingFailed.bind(null,data,isInvite)
    });
  }

  function shouldRenderForm(data){
    var isPopup = KAMPYLE_DATA.isPopupDisplayType(data.formId);
    var isFormLoadedSuccessfully = isFormLoaded(data.formId) && isJsonDataLoaded(data.formId,false);
    var shouldShowForm = MDIGITAL_FORM_STATE.shouldFormBeShown(data.formId) && !isFormAlreadyShown(data.formId);
    return (isFormLoadedSuccessfully || isPopup) && shouldShowForm;
  }

  function onJsonFetchingFailed(data, isInvite, error){
    var jsonDataKey = KAMPYLE_DATA.getMemoryJsonKey(data.formId, isInvite);
    KAMPYLE_DATA.setMemoryData(jsonDataKey,false);
    if(!isInvite){
      KAMPYLE_EVENT_DISPATCHER.trigger(KAMPYLE_CONSTANT.EVENTS.NEB_FORM_LOADING_HAS_FAILED,{
        formId: data.formId,
        failureCause: KAMPYLE_CONSTANT.FORM_LOADING_FAILURE_CAUSE.JSON_FAILED
      });
    }
    var eventData = {errorData: {
        formId: data.formId,
        isInvite:isInvite,
        errorDetails: error
    }};
    KAMPYLE_EVENT_DISPATCHER.trigger(KAMPYLE_CONSTANT.EVENTS.MDIGITAL_COULD_NOT_FETCH_DATA, eventData);
  }

  function handleFormStateUpdated(data){
    var isPopup = KAMPYLE_DATA.isPopupDisplayType(data.formId);
    var isFormShown = MDIGITAL_FORM_STATE.isFormShown(data.formId);
    var shouldTriggerShowForm = shouldRenderForm(data);
    var shouldTriggerFormReady = (isPopup && isFormShown) || (!isPopup && shouldTriggerShowForm);

    if(shouldTriggerShowForm){
      KAMPYLE_EVENT_DISPATCHER.trigger('neb_showForm',{formId: data.formId});
      KAMPYLE_DATA.setFormState(data.formId,{
        shown: true,
        isCurrentlySubmitted : false
      });
    }
    else if (hasApplicationLoadingFailed(data.formId, false)) {
        KAMPYLE_EVENT_DISPATCHER.trigger(KAMPYLE_CONSTANT.EVENTS.NEB_FORM_LOADING_HAS_FAILED, {formId: data.formId});
    }

    if(shouldTriggerFormReady) {
        //https://jira.medallia.com/browse/NM-15204
        KAMPYLE_EVENT_DISPATCHER.trigger('neb_formReady', {formId: data.formId});
    }
  }

  function subscribeToPageEvents() {
    var eventMapping = {
      neb_pageView: [increasePageViewCounter],
      neb_showInvitation: [setInviteState, KAMPYLE_UTILS.setCurrentScrollPosition, setFocusedElement, handleInviteApplicationUpdated],
      neb_buttonClicked: [KAMPYLE_UTILS.setCurrentScrollPosition, setFocusedElement, handleShowForm],
      neb_sdkShowForm: [KAMPYLE_UTILS.setCurrentScrollPosition, setFocusedElement, handleShowForm],
      neb_skipInvitation: [KAMPYLE_UTILS.setCurrentScrollPosition, setFocusedElement, handleShowForm],
      neb_inviteLoaded: [setInviteState, handleInviteLoaded],
      neb_inviteAccepted: [setInviteState, KAMPYLE_UTILS.setCurrentScrollPosition,handleShowForm],
      neb_inviteDeclined: [setInviteState, handleInviteDeclined, KAMPYLE_UTILS.handleAfterFormPosition],
      neb_formClosed: [handleFormClosed, KAMPYLE_UTILS.handleAfterFormPosition],
      neb_popupBlocked: [handleFormClosed, KAMPYLE_UTILS.handleAfterFormPosition],
      neb_loadForm: [prepareJsonData, handleFormLoading],
      neb_loadInvitation: [prepareJsonData],
      neb_formLoaded: [handleFormLoaded],
      neb_loadMultipileForms: [loadMultipileForms],
      neb_routeToForm: [routeToForm],
      neb_formReady: [sendFormExtraData, handleVersion, loadScreenCaptureApi],
      neb_feedbackSubmitted: [handleFeedbackSubmitted],
      neb_feedbackPostSubmitted: [handleFeedbackSubmitted],
      neb_submitFeedbackFailed: [handleFeedbackSubmitted],
      neb_sdkPageView: [startCheckingTargeting],
      neb_screenCaptureLoaded: [handleScreenCaptureApiLoaded],
      neb_formLoadingHasFailed: [handleFormLoadingFailed]
    };

    KAMPYLE_EVENT_DISPATCHER.subscribeMany(eventMapping);
  }

  function getTriggerTypeByEvent(eventName) {
    var eventTriggerMapping = {
      neb_buttonClicked: 'Button',
      neb_sdkShowForm: 'ByCode',
			neb_routeToForm: 'ByCode',
      neb_skipInvitation: 'Invitation',
      neb_inviteAccepted: 'Invitation',
    };

    return eventTriggerMapping[eventName] || null;
  }

  function handleShowForm(eventName, data) {
    data = data || {};

    data.triggerType = data.triggerType || getTriggerTypeByEvent(eventName);
    KAMPYLE_DATA.saveFormExtraData(data.formId, {
      triggerType: data.triggerType,
    });
    if (data.context) {
      KAMPYLE_DATA.setMemoryData('context', data.context);
    }
    KAMPYLE_DATA.setMemoryData('currentFormId', data.formId);
    KAMPYLE_DATA.setMemoryData('formIsShown', true);
    KAMPYLE_DATA.setFormState(data.formId, { shouldBeShown: true, triggerType: data.triggerType });

    handleFormStateUpdated(data);
  }

  // Create new kampyle user session
  function createSession() {
    var referrerDifferentThanHost = KAMPYLE_FUNC.isReferrerDifferentThanHost();
    var kampyleUserSession = KAMPYLE_DATA.getData('kampyleUserSession');
    var isDirectNavigation = false;
    try {
      isDirectNavigation = document.referrer === '' || window.parent.document.referrer === '' /* In case the page is in an iframe, we should check the parent's referrer */;
    } catch(e) {
      var data = {
        errorMessage: e.message,
        errorStack: e.stack,
        additionalInfo: "createSession- failed to access document.referrer, probably CORS problem when the customer's iframe is hosted in a website with different domain."
      };
      referrerDifferentThanHost = false;

      if({"isOnPremEnabled":false,"isDigitalAnalyticsEnabled":true,"isAnalyticsTrackerEnabled":true,"isCustomEventsEnabled":true,"isScreenCaptureEnabled":true,"isPropertyMessageEnabled":true,"isAdobeAEnabled":true,"isGAEnabled":false,"isDecibelEnabled":false,"isThermoFisherTeaLeafEnabled":false,"isPartialViewEnabled":false}.isDigitalAnalyticsEnabled) {
        MDIGITAL_ANALYTICS.triggerDigitalEvent(KAMPYLE_CONSTANT.MDIGITAL_WARNING, data);
      }

    } finally {
      if (!kampyleUserSession || isDirectNavigation || referrerDifferentThanHost) {
        const sessionData = {
          user_session:kampyleUserSession,
          direct_navigation:isDirectNavigation,
          different_referrer:referrerDifferentThanHost
        }

        if(KAMPYLE_FUNC.checkProvision(KAMPYLE_CONSTANT.PROVISIONS.CREATE_SESSION)) {
          if ({"isOnPremEnabled":false,"isDigitalAnalyticsEnabled":true,"isAnalyticsTrackerEnabled":true,"isCustomEventsEnabled":true,"isScreenCaptureEnabled":true,"isPropertyMessageEnabled":true,"isAdobeAEnabled":true,"isGAEnabled":false,"isDecibelEnabled":false,"isThermoFisherTeaLeafEnabled":false,"isPartialViewEnabled":false}.isDigitalAnalyticsEnabled) {
            MDIGITAL_ANALYTICS.triggerDigitalEvent('MDigital_createSession', {additionalData:sessionData})
          }
        }

        KAMPYLE_DATA.setMemoryData('isSyncedIdentifierData', false);
        KAMPYLE_DATA.setData('kampyleUserSession', KAMPYLE_UTILS.getCurrentTimestamp());
        KAMPYLE_DATA.setData('kampyleSessionPageCounter', 0);
        addToSessionCount();
        KAMPYLE_DATA.deleteData('kampyleUserPercentile');
        KAMPYLE_DATA.deleteData('kampyleInvitePresented');
        KAMPYLE_DATA.deleteData(KAMPYLE_CONSTANT.SESSION_DATA_FIELDS.IS_SURVEY_SUBMITTED_IN_SESSION);
        if (!checkProvision(KAMPYLE_CONSTANT.PROVISIONS.DISABLE_USER_PERCENTILE_AT_CREATE_SESSION)) {
          KAMPYLE_TARGETING.setUserPercentile();
        }
        if(KAMPYLE_FUNC.checkProvision(KAMPYLE_CONSTANT.PROVISIONS.ENABLE_ANALYTICS_SESSION_EVENTS)) {
          if ({"isOnPremEnabled":false,"isDigitalAnalyticsEnabled":true,"isAnalyticsTrackerEnabled":true,"isCustomEventsEnabled":true,"isScreenCaptureEnabled":true,"isPropertyMessageEnabled":true,"isAdobeAEnabled":true,"isGAEnabled":false,"isDecibelEnabled":false,"isThermoFisherTeaLeafEnabled":false,"isPartialViewEnabled":false}.isDigitalAnalyticsEnabled) {
            MDIGITAL_ANALYTICS.triggerDigitalEvent('neb_sessionStart', {additionalData:sessionData});
          }
        }
        if(KAMPYLE_FUNC.checkProvision(KAMPYLE_CONSTANT.PROVISIONS.PARALLEL_TAB_SOLUTION)) {
          KAMPYLE_DATA.clearSessionTabs();
        }
      }
    }
  }

  function isReferrerDifferentThanHost(){
    var referrerDomain = document.referrer.match(/:\/\/(.[^/]+)/);
    if(!referrerDomain) {
      return true;
    }
    referrerDomain = referrerDomain[1];
    if(referrerDomain === window.location.host){
      return false;
    }

    var propertySharedSubdomain = KAMPYLE_DATA.getPropertySharedSubdomain();
    if(propertySharedSubdomain){
      return !KAMPYLE_UTILS.isHostMatchesSubdomain(referrerDomain, propertySharedSubdomain)
          || !KAMPYLE_UTILS.isHostMatchesSubdomain(window.location.host, propertySharedSubdomain);
    }
    return true;
  }

  function handleInviteLoaded(eventName, data) {
    data = data || {};
    if(!KAMPYLE_DATA.getMemoryData('inviteVersion')){
      var inviteVersion = KAMPYLE_UTILS.getNestedPropertyValue(data, 'inviteVersion');
      KAMPYLE_DATA.setMemoryData('inviteVersion', inviteVersion);
    }
    var formState = KAMPYLE_DATA.getFormState(data.formId) || {};
    if (formState.inviteShown) { //Meaning needs to be shown and can now send data
      handleInviteApplicationUpdated("",data);
    }
  }

  function handleFormLoading(eventName, data) {
    data = data || {};
    KAMPYLE_DATA.setFormState(data.formId, {
      loading: true,
    });
		KAMPYLE_EVENT_DISPATCHER.trigger('neb_form_loaded', { formId: data.formId });
  }

  function sendInviteInitialData(eventName, data) {
    data = data || {};

    //Send data only if invite is loaded
    if (!KAMPYLE_DATA.getFormState(data.formId).inviteLoaded) { return false; }
    KAMPYLE_UTILS.sendMessageToIframe('kampyleInvite', {
      action: 'inviteShown',
    });

    var messageData = {
        accountId: data.accountId,
        websiteId: data.websiteId,
        environment: data.enviroment,
        url: document.location.href,
        kampyle_version: window.MDIGITAL.version || '0.0.0.0',
        formId: data.formId,
        cookie_size: KAMPYLE_UTILS.getByteSize(document.cookie),
        isWCAG: KAMPYLE_DATA.isFeatureEnabled('WCAG'),
        deviceType: checkDevice(),
        provisions: getAllProvisions(),
        position: KAMPYLE_VIEW.getInvitePosition(data.formId),
        customCssUpload : KAMPYLE_DATA.isFeatureEnabled(KAMPYLE_CONSTANT.PROPERTY_SETTINGS.CUSTOM_CSS_UPLOAD)
    };


    if (KAMPYLE_FUNC.checkProvision(KAMPYLE_CONSTANT.PROVISIONS.FORM_TEMPLATE_DATA_SEPERATION)) { // if separateFormTemplateFromData provision is on, we are doing async call to get the jsonData before sending message to iframe
      var callbackFunction = function(jsonData) {
        var formData = KAMPYLE_DATA.getFormData(data.formId);
        var onsiteConfiguration = MDIGITAL_CONFIGURATION.getOnsiteConfiguration();
        //Add configuration for invitation
        var extraMessageData = {
          submitUrlPrefix : onsiteConfiguration.submitUrlPrefix,
          submitUrlSuffix : onsiteConfiguration.submitUrlSuffix,
          globalResourcesUrl : onsiteConfiguration.globalResourcesUrl,
          versionedResourcesUrl : formData.versionedResourcesUrl
        };
        messageData = Object.assign({}, messageData, { inviteData: jsonData }, extraMessageData);
        messageData.formLanguage = MDIGITAL_LOCALIZATION.getFormLanguage(data.formId) || null;

        KAMPYLE_UTILS.sendMessageToIframe('kampyleInvite', {
            action: 'setExtraData',
            data: messageData,
        });
      };

      var onError = function (error) {
        console.error(error);
      };

      KAMPYLE_DATA.fetchFormJsonData({formId: data.formId, callback: callbackFunction, onError: onError, isInvite: true}, true /* second function call */)
    } else {
      KAMPYLE_UTILS.sendMessageToIframe('kampyleInvite', { // sending message to iframe without the seperation of the jsonData
        action: 'setExtraData',
        data: messageData,
      });
    }
  }

  function setInviteState(eventName, data) {
    KAMPYLE_UTILS.sendMessageToIframe('kampyleInvite', {
      action: KAMPYLE_CONSTANT.EVENTS.MDIGITAL_VALIDATE_ORIGIN,
    }); // we need to send a message to validate if origin is valid before we show the invite

    data = data || {};
    data.formId = data.formId || KAMPYLE_DATA.getMemoryData('currentFormId');

    switch (eventName) {
      case 'neb_showInvitation':
        KAMPYLE_DATA.setFormState(data.formId, {
          inviteShown: true,
        });
        break;
      case 'neb_inviteDeclined':
      case 'neb_inviteAccepted':
        KAMPYLE_DATA.setFormState(data.formId, {
          inviteShown: false,
        });
        break;
      case 'neb_inviteLoaded':
        KAMPYLE_DATA.setFormState(data.formId, {
          inviteLoaded: true,
        });
        break;
      case 'neb_sdkPageView':
        KAMPYLE_DATA.setFormState(data.formId, {
          inviteLoaded: null,
          inviteShown: false,
        });
        break;
      default:
        KAMPYLE_UTILS.showWarning('Unhandled event name ' + eventName);
    }
  }

  function updatePreviewIframeStyle(formData) {
    var currentFormId = formData.formId;

    var formWidth;
    var formHeight;
    if (formData) {
      formWidth = parseInt(formData.formWidth, 10);
      formHeight = parseInt(formData.formHeight, 10);
    }

    var hostWidth = document.documentElement.clientWidth;
    var hostHeight = document.documentElement.clientHeight;

    var innerContainerStyle = {
      overflowY: 'auto',
      height: '100%',
    };

    KAMPYLE_UTILS.setElementStyle(document.getElementById('innerContainer'), innerContainerStyle);

    //TODO - nowe that the iFrame takes 100% of the page, remove some of the logic
    var iframeStyleObject = {
      border: 0,
      position: 'relative',
      margin: '50px auto 50px',
      height: formHeight + 'px',
      width: formWidth + 'px',
    };

    if (hostWidth > formWidth && hostHeight > formHeight) { //Meaning no need to scroll
      if (KAMPYLE_DATA.isCustomHtmlAndFixedSizeForm(currentFormId)) {
        iframeStyleObject = {
          position: 'absolute',
          top: '50%',
          'margin-top': - formHeight / 2 + 'px',
          left: '50%',
          'margin-left': - formWidth / 2 + 'px',
          height: formHeight + 'px',
          width: formWidth + 'px',
        };
      }
      else {
        iframeStyleObject = {
          position: 'fixed',
          height: '100%',
          width: '100%',
        };
      }
    }

    var modal = document.getElementById('kampyleFormModal');
    if (modal && modal.style && modal.removeAttribute) {
      modal.removeAttribute('style');

      KAMPYLE_UTILS.setElementStyle(modal, iframeStyleObject);
    }
  }

  function showPreviewForm() {

    var formHeight = 450;
    var formWidth = 450;
    var formUrl = KAMPYLE_UTILS.getUrlParam('url');
    var url;

    if (KAMPYLE_DATA.getMemoryData('kampyleDevice') === KAMPYLE_CONSTANT.DEVICES.MOBILE) {
      formWidth = '100%';
      formHeight = '100%';
    }
    else {
      var height = KAMPYLE_UTILS.getUrlParam('height');
      var width = KAMPYLE_UTILS.getUrlParam('width');

      if (!!height && !isNaN(height)) {
        formHeight = height;
      }
      if (!!width && !isNaN(width)) {
        formWidth = width;
      }
    }
    //validateKampyleDomain(url) checks if the URL is ours to prevent injection
    if (!!formUrl && KAMPYLE_UTILS.validateKampyleDomain(decodeURIComponent(formUrl))) {
      formUrl = decodeURIComponent(formUrl);
      formUrl += '?region=' + KAMPYLE_DATA.getMemoryData('region');

      var formId = KAMPYLE_UTILS.getUrlParam('formId');

      if (!!formId) {
        formUrl += '&formId=' + formId;
        KAMPYLE_DATA.setMemoryData('currentFormId', formId);
      }
      else {
        url = location.protocol + '//' + location.host;
        window.location = url + '/#/error/404';
      }

      var provisions = decodeURIComponent(window.getUrlParam('provisions'));
      if (!!provisions) {
        formUrl += '&provisions=' + encodeURIComponent(provisions);
      }

      var currentWebsiteId = decodeURIComponent(window.getUrlParam('websiteId'));
      if (!!currentWebsiteId) {
        formUrl += '&websiteId=' + encodeURIComponent(currentWebsiteId);
      }

      //Format type
      var type = KAMPYLE_UTILS.getUrlParam('type') || 'direct';
      var validTypes = ['live', 'direct', 'preview'];
      if (validTypes.indexOf(type.toLowerCase()) === -1) { //Invalid name
        type = 'direct';
      }
      formUrl += '&type=' + type;

      //Custom html forms should be in the old implementation of creating iframes with the form's dimensions
      //TODO - move openning preview forms to KAMPYLE SDK
      var iframeHeight = '100%';
      var iframeWidth = '100%';
      if (KAMPYLE_DATA.isCustomHtmlAndFixedSizeForm(formId)) {
        iframeHeight = formHeight;
        iframeWidth = formWidth;
      }
      var iframe = KAMPYLE_UTILS.createIframe(formUrl, iframeWidth, iframeHeight, KAMPYLE_CONSTANT.IFRAME_SETTINGS.PREVIEW.IFRAME_ID + formId);

      //In order for the iframe to fix its styles, need to explicitly call this method
      //TODO - remove it
      // DUPLICATE OF updateIframeStyle
      if (KAMPYLE_DATA.isCustomHtmlForm(formId)) {
        updatePreviewIframeStyle({
          formId: formId,
          formHeight: formHeight,
          formWidth: formWidth,

        });
      }

      var modal = document.getElementById('kampyleFormModal');
      if (!!modal) {
        modal.appendChild(iframe);
        // check if the distance between the iframe and the window is smaller than 50px
        if (iframe.offsetTop < 30 && !KAMPYLE_DATA.getMemoryData('kampyleDevice') === KAMPYLE_CONSTANT.DEVICES.MOBILE) {
        // aadding the gap so that the min offset from the window will be 50px
          modal.style.paddingTop = 30 - iframe.offsetTop + 'px';
        }
      }

    }
    else { //Redirect to 404
      url = location.protocol + '//' + location.host;
      window.location = url + '/#/error/404';
    }
  }

  function getUserIdentifierVal() {
      var identifierCustomParam = KAMPYLE_DATA.getUserIdentifier();
      if (!identifierCustomParam) {
        return null;
      }

      var userIdentifierVal = CUSTOM_PARAMETERS.getCustomParamValue({
          name: identifierCustomParam.source_name,
          type: identifierCustomParam.type,
          source: identifierCustomParam.source,
      });

      if (!userIdentifierVal) {
        return null;
      }
      return userIdentifierVal;
  }

  function setIdentifierData(identifierData) {
    KAMPYLE_DATA.setMemoryData('isSyncedIdentifierData', true);
    updateIdentifierDataIfNecessary(identifierData.data);
  }

    function updateIdentifierDataIfNecessary(identifierData) {
        updateIdentifierDataIntegerIfNecessary(identifierData.DECLINED_DATE, 'DECLINED_DATE');
        updateIdentifierDataIntegerIfNecessary(identifierData.SUBMITTED_DATE, 'SUBMITTED_DATE');
    }

    function updateIdentifierDataIntegerIfNecessary(identifierDataValue, userStateString) {
        var localStorageDate = parseInt(KAMPYLE_DATA.getData(userStateString));
        localStorageDate = localStorageDate ? localStorageDate : null;
        var identifierDataToSync = {
          identifierDataState: userStateString,
          identifierValOnLocalStorage: localStorageDate
        };
        var identifierDataValues = {
          identifierDataState: userStateString,
          identifierValOnSbt: identifierDataValue,
          identifierValOnLocalStorage: localStorageDate
        };
        identifierDataValue = identifierDataValue ? identifierDataValue : null;

        if (identifierDataValue === localStorageDate) {
          return null;
        }
        if ((identifierDataValue !== null && localStorageDate === null) || identifierDataValue > localStorageDate) {
            KAMPYLE_DATA.setData(userStateString, identifierDataValue);
        }
        else if ((localStorageDate !== null && identifierDataValue === null) || identifierDataValue < localStorageDate) {
          KAMPYLE_FUNC.updateTargeting(userStateString, localStorageDate);
        }
        else {
            KAMPYLE_UTILS.showWarning('special case');
        }
    }

    function syncIdentifierData(userIdentifierVal, callback) {
        var propertyId = MDIGITAL_CONFIGURATION.getOnsiteConfiguration().websiteId || null;
        var urlPrefix = KAMPYLE_DATA.getServerBasedTargetingPrefix();
        var envPrefix = KAMPYLE_DATA.getServerBasedTargetingEnv();
        var url = urlPrefix + '/api/targeting/property/' + envPrefix + propertyId + '/identity/' + userIdentifierVal;
        var onSuccess = onSyncIdentifierDataSuccess.bind(null, callback);
        var onFailure = onSyncIdentifierDataFailure.bind(null, callback);
        KAMPYLE_UTILS.httpRequest(KAMPYLE_CONSTANT.HTTP_METHODS.GET, url, null, onSuccess, onFailure);
    }

    function onSyncIdentifierDataSuccess(callback, data) {
      if (!data || data.error) {
        if({"isOnPremEnabled":false,"isDigitalAnalyticsEnabled":true,"isAnalyticsTrackerEnabled":true,"isCustomEventsEnabled":true,"isScreenCaptureEnabled":true,"isPropertyMessageEnabled":true,"isAdobeAEnabled":true,"isGAEnabled":false,"isDecibelEnabled":false,"isThermoFisherTeaLeafEnabled":false,"isPartialViewEnabled":false}.isDigitalAnalyticsEnabled) {
          MDIGITAL_ANALYTICS.triggerDigitalAnalyticsEventDispatcherError({ errorMessage: 'Invalid identifier data. Data: ' + JSON.stringify(data)});
        }
      } else {
        setIdentifierData(data);
      }
      typeof callback === 'function' && callback();
    }

    function onSyncIdentifierDataFailure(callback, error) {
      if({"isOnPremEnabled":false,"isDigitalAnalyticsEnabled":true,"isAnalyticsTrackerEnabled":true,"isCustomEventsEnabled":true,"isScreenCaptureEnabled":true,"isPropertyMessageEnabled":true,"isAdobeAEnabled":true,"isGAEnabled":false,"isDecibelEnabled":false,"isThermoFisherTeaLeafEnabled":false,"isPartialViewEnabled":false}.isDigitalAnalyticsEnabled) {
        MDIGITAL_ANALYTICS.triggerDigitalAnalyticsEventDispatcherError({ errorMessage: 'Failed to fetch identifier data. Error: ' + JSON.stringify(error)});
      }
      typeof callback === 'function' &&  callback();
    }

    function shouldSyncIdentifier(newUserIdentifierVal) {
      var prevUserIdentifierVal = KAMPYLE_DATA.getMemoryData('identifierValue');
      var isSyncedIdentifierData = KAMPYLE_DATA.getMemoryData('isSyncedIdentifierData') === true;
      var isSBTOn = !!KAMPYLE_FUNC.checkProvision(KAMPYLE_CONSTANT.PROVISIONS.SERVER_BASED_TARGETING);
      var isIdentifiedUser = !!newUserIdentifierVal;
      return isIdentifiedUser && isSBTOn && (!isSyncedIdentifierData || prevUserIdentifierVal !== newUserIdentifierVal);
    }

    function startCheckingTargeting() {
      if (isAnyOtherFormAlreadyShown()) {
        return false;
      }
      KAMPYLE_DATA.setMemoryData('isInvitationShouldBeIgnored',false);
      KAMPYLE_EVENT_DISPATCHER.trigger('neb_pageView');
      if (window.KAMPYLE_ONSITE_STATE !== 'manual') { //TODO! this is a workaround
				var shouldSkipInviteTargeting = KAMPYLE_DATA.isFeatureEnabled(KAMPYLE_CONSTANT.PROPERTY_SETTINGS.MANUALLY_INVITE_TARGETING);
 				KAMPYLE_EVENT_DISPATCHER.trigger('neb_targetingInit', { skipInviteTargeting: shouldSkipInviteTargeting });
      }
  }

  function increasePageViewCounter() {
    var sessionPageCounter = KAMPYLE_DATA.getData('kampyleSessionPageCounter') || 0;
    sessionPageCounter = parseInt(sessionPageCounter);
    KAMPYLE_DATA.setData('kampyleSessionPageCounter', ++sessionPageCounter);
  }

  function setQuarantineDeclinedDate(eventName) {
    var declinedDateKey = "DECLINED_DATE";
    var date = KAMPYLE_UTILS.getCurrentTimestamp();
    KAMPYLE_DATA.setData(declinedDateKey, date);
    if (KAMPYLE_FUNC.checkProvision(KAMPYLE_CONSTANT.PROVISIONS.SERVER_BASED_TARGETING)) {
      KAMPYLE_EVENT_DISPATCHER.trigger(eventName, { declinedDate: date });
    }
    updateTargeting(declinedDateKey, date);
  }

  function handleFormClosed(eventName, data) {
    data = data || {};

    if (!data.isFormSubmitted && (!KAMPYLE_FUNC.checkProvision(KAMPYLE_CONSTANT.PROVISIONS.EXEMPT_FORMS_FROM_QUARANTINE) || KAMPYLE_DATA.isFormOfType(data.formId, KAMPYLE_CONSTANT.FORM_TYPES.INVITATION))) {
      KAMPYLE_FUNC.setQuarantineDeclinedDate(KAMPYLE_CONSTANT.EVENTS.MDIGITAL_UPDATE_TARGETING_WITH_DECLINED_DATE_FORM_CLOSED);
    }

    //TODO - remove this variable
    KAMPYLE_DATA.setMemoryData('formIsShown', false);
    KAMPYLE_DATA.setFormState(data.formId, {
      shouldBeShown: false,
      shown:false,
      loaded: null
    });

    finishFormClosed(data.formId);
  }

  function finishFormClosed(formId) {
    //Show the current button - delay if its an animation one
    var buttonFormId = KAMPYLE_DATA.getMemoryData('buttonFormId');
    var formData = KAMPYLE_DATA.getFormData(buttonFormId);
    var delay = KAMPYLE_DATA.getDisplayType(formData) === 'animation' ? 1000 : 0

    if (buttonFormId) {
      setTimeout(function () {
        KAMPYLE_EVENT_DISPATCHER.trigger('neb_showButton', { formId: buttonFormId, formClosed: true });
        triggerFormClosedEvents(formId);
        refocusActiveElement();
      }, delay);
    }
    else {
      triggerFormClosedEvents(formId);
      refocusActiveElement();
    }
  }

  function triggerFormClosedEvents(formId) {
    KAMPYLE_EVENT_DISPATCHER.trigger('neb_afterFormClosed', { formId: formId });
    KAMPYLE_UTILS.triggerCustomEvent('neb_formClosed', { formId: formId });
  }

  function updateTargeting(stateType, data) {
    if (!!KAMPYLE_FUNC.checkProvision(KAMPYLE_CONSTANT.PROVISIONS.SERVER_BASED_TARGETING) && !!KAMPYLE_DATA.getMemoryData('identifierValue')) {
        var dataJson = {};
        dataJson[stateType] = data;
        var urlPrefix = KAMPYLE_DATA.getServerBasedTargetingPrefix();
        var envPrefix = KAMPYLE_DATA.getServerBasedTargetingEnv();
        var url = urlPrefix + '/api/targeting/property/' + envPrefix + MDIGITAL_CONFIGURATION.getOnsiteConfiguration().websiteId + '/identity/' + encodeURIComponent(KAMPYLE_DATA.getMemoryData('identifierValue'));
        var dataStateType = dataJson[stateType];

        var dataObjForSbt = {
          dataState: dataStateType,
          dataValue: data
        };

        KAMPYLE_EVENT_DISPATCHER.trigger('MDigital_updatingSbtServer', dataObjForSbt);

        KAMPYLE_UTILS.httpRequest(KAMPYLE_CONSTANT.HTTP_METHODS.POST, url, dataJson);
    }
  }

  function setQuarantineSubmittedDate() {
    var submittedDateKey = "SUBMITTED_DATE";
    var date = KAMPYLE_UTILS.getCurrentTimestamp();
    KAMPYLE_DATA.setData(submittedDateKey, date);
    if (!!KAMPYLE_FUNC.checkProvision(KAMPYLE_CONSTANT.PROVISIONS.SERVER_BASED_TARGETING)) {
      KAMPYLE_EVENT_DISPATCHER.trigger('MDigital_updateTargetingWithSubmittedDate', { submittedDate: date });
    }
    updateTargeting(submittedDateKey, date);
  }

  function exemptQuarantineSubmittedDateByFormType(formId) {
    switch(KAMPYLE_DATA.getFormTriggerType(formId)){
      case KAMPYLE_CONSTANT.FORM_TYPES.BUTTON:
        return KAMPYLE_DATA.isFeatureEnabled(KAMPYLE_CONSTANT.FEATURE_FLAGS.EXEMPT_BUTTON_FORMS_FROM_QUARANTINE);
      case KAMPYLE_CONSTANT.FORM_TYPES.CODE:
        return KAMPYLE_DATA.isFeatureEnabled(KAMPYLE_CONSTANT.FEATURE_FLAGS.EXEMPT_CODE_FORMS_FROM_QUARANTINE);
      case KAMPYLE_CONSTANT.FORM_TYPES.EMBEDDED:
        return KAMPYLE_DATA.isFeatureEnabled(KAMPYLE_CONSTANT.FEATURE_FLAGS.EXEMPT_EMBEDDED_FORMS_FROM_QUARANTINE);
      default:
        return false;
    }
  }

  function handleFeedbackSubmitted(eventMapping, data) {
    if (!KAMPYLE_FUNC.checkProvision(KAMPYLE_CONSTANT.PROVISIONS.EXEMPT_FORMS_FROM_QUARANTINE) || !exemptQuarantineSubmittedDateByFormType(data.formId)) {
      KAMPYLE_FUNC.setQuarantineSubmittedDate();
    }
    KAMPYLE_DATA.setData(KAMPYLE_CONSTANT.SESSION_DATA_FIELDS.IS_SURVEY_SUBMITTED_IN_SESSION, true);
    KAMPYLE_DATA.setFormState(data.formId, {isCurrentlySubmitted: true});
  }

  function handleInviteDeclined(eventName, data) {
    KAMPYLE_FUNC.setQuarantineDeclinedDate(KAMPYLE_CONSTANT.EVENTS.MDIGITAL_UPDATE_TARGETING_WITH_DECLINED_DATE_INVITE_DECLINED)
    refocusActiveElement();
  }

  function handleFormLoaded(eventName, data) {
    KAMPYLE_DATA.setFormState(data.formId, {
      loading: false,
      loaded: true,
    });
    handleFormStateUpdated(data);
  }

  function loadScreenCaptureApi (eventName, data) {
    data = data || {};
    var isScreenCaptureAsComponentEnabled = KAMPYLE_FUNC.checkProvision(KAMPYLE_CONSTANT.PROVISIONS.USER_SNAP_AS_COMPONENT);
    var shouldNotCallScreenCaptureJs = isScreenCaptureAsComponentEnabled && !isScreenCaptureAsComponentExistAndSupported(data.formId);

    if ({"isOnPremEnabled":false,"isDigitalAnalyticsEnabled":true,"isAnalyticsTrackerEnabled":true,"isCustomEventsEnabled":true,"isScreenCaptureEnabled":true,"isPropertyMessageEnabled":true,"isAdobeAEnabled":true,"isGAEnabled":false,"isDecibelEnabled":false,"isThermoFisherTeaLeafEnabled":false,"isPartialViewEnabled":false}.isScreenCaptureEnabled && !shouldNotCallScreenCaptureJs) {
      // checks whether the loaded form is has SC enabled, and the user uses supported browser.
      // TODO: beautify this function
      if (data.isScreenCaptureEnabled !== false) {
        KAMPYLE_SCREEN_CAPTURE.init(function () {
          KAMPYLE_EVENT_DISPATCHER.trigger('neb_screenCaptureLoaded', { formId: data.formId });
        });
      }
    }
  }

  function isScreenCaptureAsComponentExistAndSupported(formId) {
    var displayType = KAMPYLE_UTILS.getNestedPropertyValue(KAMPYLE_DATA.getFormData(formId), 'formDisplay.displayType');
    var isScreenCaptureSupported = displayType !== 'embedded' && !KAMPYLE_DATA.isMobile();
    if (!isScreenCaptureSupported) {
      return false;
    }
    var formPages = KAMPYLE_DATA.getMemoryJsonNestedPropertyValue(formId, "pages", false);
    var isFormV2 = KAMPYLE_DATA.isV2Form(formId);
    var componentsName = isFormV2 ? 'components' : 'dynamicData';
    var componentType = isFormV2 ? 'type' : 'component';

    return formPages.some(function (page) {
      return page[componentsName].some(function (component) {
        return component[componentType] === "screenCaptureComponent";
      });
    });
  }

  function handleScreenCaptureApiLoaded (eventName, data) {
    data = data || {};
    var formData = KAMPYLE_DATA.getFormData(data.formId);
    var iframePrefix;
    switch (KAMPYLE_DATA.getDisplayType(formData)) {
      case KAMPYLE_CONSTANT.DISPLAY_TYPES.LIGHTBOX:
        iframePrefix = KAMPYLE_CONSTANT.IFRAME_SETTINGS.LIGHTBOX.IFRAME_ID_PREFIX;
        break;
      case KAMPYLE_CONSTANT.DISPLAY_TYPES.ANIMATION:
        iframePrefix = KAMPYLE_CONSTANT.IFRAME_SETTINGS.ANIMATION.IFRAME_ID;
        break;
      default:
        iframePrefix = KAMPYLE_CONSTANT.IFRAME_SETTINGS.PREVIEW.IFRAME_ID;
    }
    var iframeId = iframePrefix + data.formId;

    KAMPYLE_UTILS.sendMessageToIframe(iframeId, { action: 'screenCaptureLoaded' });
  }


  function setFocusedElement() {
    //Save last focused element for aria purposes
    KAMPYLE_DATA.setMemoryData('kampyleFocusedElement', document.activeElement);
  }

  function refocusActiveElement() {
    var focused = KAMPYLE_DATA.getMemoryData('kampyleFocusedElement');
    if (focused && focused.focus) {
      focused.focus();
    }
  }

  function checkProvision(name) {
    var dataObj = MDIGITAL_CONFIGURATION.getOnsiteConfiguration();
    return !!name && !!dataObj && !!dataObj.provisions &&
          (!!dataObj.provisions[name] || dataObj.provisions[name] === 'true');
  }

  function getAllProvisions() {
    var allProvisions = MDIGITAL_CONFIGURATION.getOnsiteConfiguration().provisions;
    var provisions = {};
    for (var provision in allProvisions) {
      if (allProvisions.hasOwnProperty(provision)) {
        provisions[provision] = KAMPYLE_FUNC.checkProvision(provision);
      }
    }
     return provisions;
  }

  function checkDevice() {
    if (!KAMPYLE_DATA.getMemoryData('kampyleDevice')) {
      KAMPYLE_DATA.setMemoryData('kampyleDevice', KAMPYLE_UTILS.getDeviceTypeByUserAgent(navigator.userAgent, navigator.userAgentData));
    }
    return KAMPYLE_DATA.getMemoryData('kampyleDevice') || 'desktop';
  }

  function addScreenCaptureData(messageData) {
    var version = KAMPYLE_DATA.getMemoryData('version');

    if (version === 1) {
      messageData.screenCapture = { isTaken: false };
    }
    else {
      messageData.integrations.screenCapture = { isTaken: false };
    }
    return messageData;
  }

  function handleBeforeFormShown(formId, jsonData) {
    var deviceType = KAMPYLE_DATA.getMemoryData('kampyleDevice');
    if (KAMPYLE_FUNC.checkProvision(KAMPYLE_CONSTANT.PROVISIONS.ENABLE_PARTIAL_VIEW) && KAMPYLE_DATA.isMobile()) {
      var ratioKey = deviceType === KAMPYLE_CONSTANT.DEVICES.TABLET
          ? 'partialViewRatioTablet'
          : 'partialViewRatioMobile';
      KAMPYLE_DATA.setFormState(formId, {
        ratio: KAMPYLE_UTILS.getNestedPropertyValue(jsonData, 'settings.formBasicSettings.' + ratioKey)
      });
    }
    KAMPYLE_EVENT_DISPATCHER.trigger('neb_beforeFormShown', {formId: formId});
  }

  function sendFormExtraData(eventName, data) {
    data = data || {};
    var formData = KAMPYLE_DATA.getFormData(data.formId);
    if (!formData || !data.formId) { return false; }
    var formState = KAMPYLE_DATA.getFormState(data.formId);

    var targetWindow;
    var currIframe;

    var formDisplayType = KAMPYLE_DATA.getDisplayType(formData);
    switch (formDisplayType) {
      case 'animation':
        currIframe = document.getElementById(KAMPYLE_CONSTANT.IFRAME_SETTINGS.ANIMATION.IFRAME_ID + data.formId);
        break;
      case 'lightbox':
        currIframe = document.getElementById(KAMPYLE_CONSTANT.IFRAME_SETTINGS.LIGHTBOX.IFRAME_ID_PREFIX + data.formId);
        break;
      case 'popup':
        targetWindow = KAMPYLE_DATA.getMemoryData('popupHandler');
        break;
      case KAMPYLE_CONSTANT.DISPLAY_TYPES.EMBEDDED:
        currIframe = document.getElementById(KAMPYLE_CONSTANT.IFRAME_SETTINGS.EMBEDDED.IFRAME_ID_PREFIX + data.formId);
        break;

      default:
        KAMPYLE_UTILS.showWarning('Invalid display type - ' + formDisplayType);
        return false;
    }


    //Handling for 'animateddisplay' & 'onpagelightbox'
    //TODO - change origin to strict kampyle domain
    var origin = '*';
    if (currIframe && currIframe.getAttribute) {
      origin = currIframe.getAttribute('origin') || '*';
      targetWindow = currIframe.contentWindow;
    }

    //TODO - refactor into sendMessage method like in app.js
    if (targetWindow && targetWindow.postMessage) {
      var messageData = getCustomParamsMessage(data.formId);
      targetWindow.postMessage(messageData, origin);

      var isExtensionEnabled = KAMPYLE_FUNC.checkProvision(KAMPYLE_CONSTANT.PROVISIONS.EXTENSION_ENABLED);
      if (isExtensionEnabled) {
        var authorizationMessage = KAMPYLE_MESSAGE.getAuthorizationMessage();
        targetWindow.postMessage(authorizationMessage, origin);
      }

      //For custom HTML - Notify the form to update form id in session storage
      messageData = '{"action": "setFormId","formId" : ' + data.formId + ', "__isDigitalAction": true}';
      targetWindow.postMessage(messageData, origin);

      messageData = {
        action: 'setExtraData',
        __isDigitalAction: true
      };
      messageData.clientHints = KAMPYLE_UTILS.safeJsonParse(KAMPYLE_CONSTANT.PLACEHOLDERS.USER_AGENT_CLIENT_HINTS_LIST) || [];
      messageData.provisions = getAllProvisions();
      messageData.integrations = KAMPYLE_INTEGRATION.getIntegrationData();

      if({"isOnPremEnabled":false,"isDigitalAnalyticsEnabled":true,"isAnalyticsTrackerEnabled":true,"isCustomEventsEnabled":true,"isScreenCaptureEnabled":true,"isPropertyMessageEnabled":true,"isAdobeAEnabled":true,"isGAEnabled":false,"isDecibelEnabled":false,"isThermoFisherTeaLeafEnabled":false,"isPartialViewEnabled":false}.isDecibelEnabled) {
        var decibelData = KAMPYLE_DATA.getMemoryData(KAMPYLE_CONSTANT.MEMORY_DATA_FIELDS.DECIBEL_DATA);
        Object.assign(messageData.integrations, {
          decibel: decibelData
        });
      }
      messageData.websiteId = MDIGITAL_CONFIGURATION.getOnsiteConfiguration().websiteId || null;
      messageData.device = KAMPYLE_DATA.getMemoryData('kampyleDevice');
      messageData.context = KAMPYLE_DATA.getMemoryData('context');
      messageData.url = encodeURIComponent(document.location.href);
      messageData.customCssUpload = KAMPYLE_DATA.isFeatureEnabled(KAMPYLE_CONSTANT.PROPERTY_SETTINGS.CUSTOM_CSS_UPLOAD);

      if({"isOnPremEnabled":false,"isDigitalAnalyticsEnabled":true,"isAnalyticsTrackerEnabled":true,"isCustomEventsEnabled":true,"isScreenCaptureEnabled":true,"isPropertyMessageEnabled":true,"isAdobeAEnabled":true,"isGAEnabled":false,"isDecibelEnabled":false,"isThermoFisherTeaLeafEnabled":false,"isPartialViewEnabled":false}.isScreenCaptureEnabled) {
        messageData = addScreenCaptureData(messageData);
        messageData.isScreenCaptureEnabled = KAMPYLE_SCREEN_CAPTURE.isScreenCaptureEnabled(data.formId);
        messageData.provisions.screenCapture = KAMPYLE_FUNC.checkProvision('screenCapture') || KAMPYLE_FUNC.checkProvision('screenCaptureEnabled');
       }

      //Add display type
      messageData.displayType = KAMPYLE_DATA.getDisplayType(formData);
      // Default triggerType for popup that sends the extra data twice (we have to send triggerType for auto-advance/auto-submit)
      messageData.triggerType = formState.triggerType;

      //Add configuration for form app
      var onsiteConfiguration = MDIGITAL_CONFIGURATION.getOnsiteConfiguration();
      Object.assign(messageData, {
        submitUrlPrefix : onsiteConfiguration.submitUrlPrefix,
        submitUrlSuffix : onsiteConfiguration.submitUrlSuffix,
        submitUrlWithBackendUUID: onsiteConfiguration.submitUrlWithBackendUUID,
        globalResourcesUrl : onsiteConfiguration.globalResourcesUrl,
        versionedResourcesUrl : formData.versionedResourcesUrl,
        textAreaLimit : onsiteConfiguration.textAreaLimit
      });

      if (KAMPYLE_FUNC.checkProvision(KAMPYLE_CONSTANT.PROVISIONS.SERVER_BASED_TARGETING)) {
          messageData.endUserIdentifier = getUserIdentifierVal();
          KAMPYLE_EVENT_DISPATCHER.trigger('neb_initUserIdentifierOnExtraData', { hasIdentifierValue: messageData.endUserIdentifier !== null });
      }

      if({"isOnPremEnabled":false,"isDigitalAnalyticsEnabled":true,"isAnalyticsTrackerEnabled":true,"isCustomEventsEnabled":true,"isScreenCaptureEnabled":true,"isPropertyMessageEnabled":true,"isAdobeAEnabled":true,"isGAEnabled":false,"isDecibelEnabled":false,"isThermoFisherTeaLeafEnabled":false,"isPartialViewEnabled":false}.isOnPremEnabled) {
        messageData.onPremPackageVersion = MDIGITAL_ON_PREM.getPackageVersion();
      }
      // TODO: remove this and use messageData.triggerType instead
      //Add saved extra data that was stored via the SDK
      var pendingExtraData = KAMPYLE_DATA.flushFormExtraData(data.formId);
      if (pendingExtraData) {
        for (var extra in pendingExtraData) {
          if (pendingExtraData.hasOwnProperty(extra)) {
            messageData[extra] = pendingExtraData[extra];
          }
        }
      }

      if (KAMPYLE_FUNC.checkProvision(KAMPYLE_CONSTANT.PROVISIONS.FORM_TEMPLATE_DATA_SEPERATION)) {
        var callbackFunction = function(jsonData) {
            messageData = Object.assign({}, messageData, { formData: jsonData });
            messageData.formLanguage = MDIGITAL_LOCALIZATION.getFormLanguage(data.formId) || null;
            handleBeforeFormShown(data.formId, jsonData);
            targetWindow.postMessage(JSON.stringify(messageData), origin);
        };

        var onError = function (error) {
          console.error(error);
        };

        KAMPYLE_DATA.fetchFormJsonData({formId: formData.formId, callback: callbackFunction, onError:onError }, true /* second function call */);
      } else {
        targetWindow.postMessage(JSON.stringify(messageData), origin);
      }
    }

    KAMPYLE_EVENT_DISPATCHER.trigger('neb_formShown', {
      formId: data.formId,
      feedbackCorrelationUUID: data.feedbackCorrelationUUID,
    });
  }

  function getCustomParamsMessage(formId) {
    if (CUSTOM_PARAMETERS.hasCustomParams(formId)) {
      var customParams = CUSTOM_PARAMETERS.formatCustomParams(formId);
      //Send the formatted custom params to the live form
      return '{"action": "customParamsLoaded","customParams" : ' + JSON.stringify(customParams) + ', "__isDigitalAction": true}';
    }
  }

  function handleVersion(eventName, data) {
    data = data || {};
    KAMPYLE_DATA.setMemoryData('NEB_FORM_VERSION', data.formVersion || 0); // backwards compatibility - if there is no version add 0
  }

  function isAnyInviteShown() {
    var allFormStates = KAMPYLE_DATA.getMemoryData('formsState') || {};
    for (var formId in allFormStates) {
      if (allFormStates.hasOwnProperty(formId)) {
        if (allFormStates[formId].inviteShown) {
          return true;
        }
      }
    }

    return false;
  }

  //Check if there is some form that is currently displayed that blocked others forms from being displayed
  function isAnyOtherFormAlreadyShown(currentFormId,shouldIgnoreSkipInvitation) {
    var allFormStates = KAMPYLE_DATA.getMemoryData('formsState') || {};
    for (var formId in allFormStates) {
      if (allFormStates.hasOwnProperty(formId)) {
        //We should not ignore if current form already shown and not just in showing proccess
        var shouldIgnoreForm = !MDIGITAL_FORM_STATE.isFormShown(formId) && ((currentFormId && currentFormId == formId) || shouldIgnoreSkipInvitation && KAMPYLE_DATA.isSkipInvitation(formId))
        //If form type is button or sdk we should ignore the skip invitation form and render the button / sdk
        if ( (allFormStates[formId].shown ||  allFormStates[formId].shouldBeShown) && !KAMPYLE_DATA.isEmbeddedDisplayType(formId) && !shouldIgnoreForm) {
          return true;
        }
      }
    }
    return false;
  }



  function getSafeCustomParamVal(currParam) {
    currParam = currParam || {};
    var currParamVal = currParam.value;
    var currParamType = currParam.type || '';
    if (currParamVal === undefined) {
     currParamVal = CUSTOM_PARAMETERS.fetchCPValue(currParam);
    }
    if (currParamVal !== null) {
      switch (currParamType.toLowerCase()) {
        //Try casting the value to its type
        case 'datetime':
          //Special case where the timestamp is a string
          if (typeof currParamVal === 'string')
          {
            currParamVal = parseInt(currParamVal) || null;
          }
          else if (!(currParamVal instanceof Date) &&
                  (!currParamVal.getTime || isNaN(currParamVal.getTime()))) //invalid date will give isNaN(currParamVal.getTime() true
          {
            currParamVal = null;
          }
          else {
            currParamVal = currParamVal.getTime();
          }
          break;
        case 'number':
          currParamVal = KAMPYLE_UTILS.getNumericValue(currParamVal);
          break;
        case 'text':
          if (typeof(currParamVal) !== 'string')
          {
            currParamVal = null;
          }
          break;
        case 'boolean':
          //boolean cast
          if (currParamVal === 'true')
          {
            currParamVal = true;
          }
          else if (currParamVal === 'false')
          {
            currParamVal = false;
          }

          if (typeof(currParamVal) !== 'boolean')
          {
            currParamVal = null;
          }
          break;
        default:
          currParamVal = null;
          console.error('Invalid custom parameter type ' + currParamType);
          break;
      }
    }

    return currParamVal;
  }

  function isPreloadConfigured() {
    var data = MDIGITAL_CONFIGURATION.getOnsiteConfiguration();
    return (!!data && data.isFormsPreloaded !== 'false' && data.isFormsPreloaded !== false);
  }

  function addToSessionCount() {
    var kampyleUserSessionsCount = KAMPYLE_DATA.getData('kampyleUserSessionsCount');
    kampyleUserSessionsCount = Number(kampyleUserSessionsCount) || 0;
    KAMPYLE_DATA.setData('kampyleUserSessionsCount', ++kampyleUserSessionsCount);
  }

  function handleHashChanged() {
    if (KAMPYLE_DATA.isFeatureEnabled('SPA')) {
      KAMPYLE_ONSITE_SDK.updatePageView();
    }
  }

  //Backwards compatibility for old forms -> move implementation to use SDK
  function kampyleButtonClicked(formData) {
    formData = formData || {};
    KAMPYLE_EVENT_DISPATCHER.trigger('neb_buttonClicked', {
      formId: formData.formId,
    });
  }

  function getTimeInSession() {
    var sessionStartTimestamp = Number(KAMPYLE_DATA.getData('kampyleUserSession'));
    return !!sessionStartTimestamp ? Math.floor(KAMPYLE_UTILS.getTimeDiff(sessionStartTimestamp, KAMPYLE_CONSTANT.TIME_FORMATS.SECONDS)) : 0;
  }

  function getTimeOnPage() {
    var timeOnPage = Number(KAMPYLE_DATA.getData('kampylePageLoadedTimestamp'));
    return !!timeOnPage ? Math.floor(KAMPYLE_UTILS.getTimeDiff(timeOnPage, KAMPYLE_CONSTANT.TIME_FORMATS.SECONDS)) : 0;
  }

  function getLastDeclineSubmit (key) {
    var date = Number(KAMPYLE_DATA.getData(key));
    return !!date ? KAMPYLE_UTILS.getTimeDiff(date, KAMPYLE_CONSTANT.TIME_FORMATS.DAYS) : null;
  }

  function prepareInviteTriggeringData(eventName, data) {

    var deviceName = (KAMPYLE_DATA.getMemoryData('kampyleDevice') || KAMPYLE_CONSTANT.DEVICES.DESKTOP).toLowerCase();
    var formData = KAMPYLE_DATA.getFormData(data.formId);
    var inviteTriggeringData = {
      desktop: deviceName === KAMPYLE_CONSTANT.DEVICES.DESKTOP,
      mobile: deviceName === KAMPYLE_CONSTANT.DEVICES.MOBILE,
      tablet: deviceName === KAMPYLE_CONSTANT.DEVICES.TABLET,
      abandon: !!KAMPYLE_DATA.getMemoryData('targetingState.abandon'),
      time_in_session: getTimeInSession(),
      time_on_page: getTimeOnPage(),
      excluded_urls: KAMPYLE_UTILS.getNestedPropertyValue(formData, 'urlRules.exclusionUrl.rule'),
      included_urls: KAMPYLE_UTILS.getNestedPropertyValue(formData, 'urlRules.inclusionUrl.rule'),
      number_of_visits: Number(KAMPYLE_DATA.getData('kampyleUserSessionsCount')) || 1,
      last_declined: getLastDeclineSubmit('DECLINED_DATE'),
      last_feedback: getLastDeclineSubmit('SUBMITTED_DATE'),
      percentage: KAMPYLE_TARGETING.getUserPercentile(data.formId),
    };

    KAMPYLE_DATA.setMemoryData('invitationTriggeringData', inviteTriggeringData);
  }

  function isContentPayloadEnabled() {
    return KAMPYLE_FUNC.checkProvision(KAMPYLE_CONSTANT.PROVISIONS.EVENT_INCLUDE_FEEDBACK_CONTENT) ||
      KAMPYLE_FUNC.checkProvision(KAMPYLE_CONSTANT.PROVISIONS.EXPOSE_SELECTION_QUESTIONS) ||
      KAMPYLE_FUNC.checkProvision(KAMPYLE_CONSTANT.PROVISIONS.EXPOSE_VERBATIM_QUESTIONS)
  }

  export default {
    // for testing
    increasePageViewCounter: increasePageViewCounter,
	  subscribeToCustomEvents: subscribeToCustomEvents,
    subscribeToPageEvents: subscribeToPageEvents,
    createSession: createSession,
    updateTargeting: updateTargeting,
    checkProvision: checkProvision,
    getAllProvisions: getAllProvisions,
    onSyncIdentifierDataSuccess: onSyncIdentifierDataSuccess,
    shouldRenderForm: shouldRenderForm,
    addScreenCaptureData: addScreenCaptureData,
    sendFormExtraData: sendFormExtraData,
    handleVersion: handleVersion,
    showPreviewForm: showPreviewForm,
    updatePreviewIframeStyle: updatePreviewIframeStyle,
    validateFormContract: validateFormContract,
    getTriggerTypeByEvent: getTriggerTypeByEvent,
    prepareInviteTriggeringData: prepareInviteTriggeringData,
    loadScreenCaptureApi: loadScreenCaptureApi,
    handleInviteLoaded: handleInviteLoaded,
    sendInviteInitialData: sendInviteInitialData,
    checkDevice: checkDevice,
    shouldSyncIdentifier: shouldSyncIdentifier,
    prepareJsonData:prepareJsonData,
    shouldSkipFetchingFormData:shouldSkipFetchingFormData,
    getTimeInSession: getTimeInSession,
    getTimeOnPage: getTimeOnPage,
    isReferrerDifferentThanHost: isReferrerDifferentThanHost,
    setQuarantineDeclinedDate:setQuarantineDeclinedDate,
    setQuarantineSubmittedDate:setQuarantineSubmittedDate,
    handleFormClosed:handleFormClosed,
    handleFeedbackSubmitted:handleFeedbackSubmitted,
    handleInviteDeclined: handleInviteDeclined,

    // Public API
    init: init,
    startCheckingTargeting: startCheckingTargeting,
    isAnyOtherFormAlreadyShown: isAnyOtherFormAlreadyShown,
    isAnyInviteShown: isAnyInviteShown,
    getSafeCustomParamVal: getSafeCustomParamVal,
    isPreloadConfigured: isPreloadConfigured,
    kampyleButtonClicked: kampyleButtonClicked,
    loadMultipileForms: loadMultipileForms,
    routeToForm: routeToForm,
    updateIdentifierDataIntegerIfNecessary: updateIdentifierDataIntegerIfNecessary,
    syncIdentifierData: syncIdentifierData,
    getUserIdentifierVal: getUserIdentifierVal,
    handleFormStateUpdated: handleFormStateUpdated,
    hasApplicationLoadingFailed: hasApplicationLoadingFailed,
    isJsonDataLoaded:isJsonDataLoaded,
    handleInviteApplicationUpdated: handleInviteApplicationUpdated,
    isFormLoaded: isFormLoaded,
    isContentPayloadEnabled: isContentPayloadEnabled,
    getCustomParamsMessage: getCustomParamsMessage,
  };

